import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";

export const GET_COMPANY = "[COMPANY EDIT] GET_COMPANY";
export const GET_COMPANY_SUCCESS =
	"[COMPANY EDIT] GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAILED =
	"[COMPANY EDIT] GET_COMPANY_FAILED";

export const EDIT_COMPANY = "[COMPANY EDIT] EDIT_COMPANY";
export const EDIT_COMPANY_SUCCESS =
	"[COMPANY EDIT] EDIT_COMPANY_SUCCESS";
export const EDIT_COMPANY_FAILED =
	"[COMPANY EDIT] EDIT_COMPANY_FAILED";

export const SET_VALUE = "[COMPANY EDIT] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY EDIT] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCompany(id: string, callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_COMPANY });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Mei/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_COMPANY_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_COMPANY_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_COMPANY_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateCompany(callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: EDIT_COMPANY });

		try {
			const state = getState();

			const { login, companyEdit } = state;

			const { item, businessName, socialName, cnpj, code, parentOperator } = companyEdit;

			const model = {
				...item,
				businessName,
				socialName,
				cnpj,
				code,
				parentOperator: parentOperator?._id || parentOperator?.id || parentOperator || undefined
			};

			const response = await api.sendPut("/Mei/" + item._id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_COMPANY_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_COMPANY_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_COMPANY_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
